// extracted by mini-css-extract-plugin
module.exports = {"root":"sd0SA6Z9","flexRowWrapper":"ffXd2Rh9","currencyLabel":"fUB9iezB"};